// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"609":"4a080bd9","772":"118dc868","787":"d41be85f"}[chunkId] + ".chunk.js";
};